export class ExportadoresModel {
  id: number;
  id_pais: number = null;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/exportadores/exportadores.model.ts